import { IDSAlert as r } from "./alert-element.js";
import { registerComponent as i } from "../../utilities/utils.js";
import "../icons/chevron/register.js";
import "../icons/close-bold/register.js";
import "../icons/attention/register.js";
import "../icons/success/register.js";
import "../icons/warning/register.js";
import "../icons/information/register.js";
import "../grid/column/register.js";
import "../grid/row/register.js";
i("ids-alert", r);